import React from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { IoIosCart } from "react-icons/io";
import { MdDelete } from 'react-icons/md';


import { motion } from "framer-motion";

const AddCard = ({ addToCart, addToWish, removeFromWish, data, deleteIcon }) => {
  return (
    <motion.div
      layout
      whileHover={{
          z: 70,
          rotateY: 5,
          boxShadow: "0 0 15px black",
          transition: { type: "spring", stiffness: 300, duration: .4}
      }}
    >
      <Card className="product-card">
        <CardMedia
          className="card-media"
          image={data.image}
          title="Paella dish"
        />
        <CardContent className="card-title">

          <Typography variant="body2" color="textSecondary" component="p">
            {data.title}
          </Typography>
        </CardContent>

        <CardActions className="card-actions" disableSpacing>

          <IconButton className="action-icon-container scale" aria-label="add to favorites">
            { deleteIcon ? 

              <MdDelete onClick={ () => removeFromWish(data.id) }
                className="action-icon action-icon-heart" /> : 
                
              <FavoriteIcon onClick={ () => addToWish(data) } 
                className="action-icon action-icon-heart" /> 
            }
          </IconButton>

          <IconButton onClick={() => addToCart(data)} className="action-icon-container scale" aria-label="share">
            <IoIosCart className="action-icon action-icon-cart"/>
          </IconButton>

          <span className="price">{`$${data.price}`}</span>
        </CardActions>
      </Card>
    </motion.div>
  );
}

export default AddCard;